import { api } from '@setplex/tria-api'
import { createEvent, sample } from 'effector'
import { entitiesHybridSearchModel } from '~/entities/hybrid-search'
import { entitiesMotnModel } from '~/entities/motn'
import { profilesModel } from '~/entities/profiles'
import { searchAutocompleteModel } from '~/features/search-autocomplete'

/**
 * Single entry point for search reset on profile switch.
 * New entity/API stores: wire here. New route UI stores: subscribe route module to this event.
 */
export const resetSearchOnProfileSwitch = createEvent()

sample({
  clock: profilesModel.updateProfileActiveStateFx.done,
  target: resetSearchOnProfileSwitch,
})

sample({
  clock: resetSearchOnProfileSwitch,
  target: [
    entitiesHybridSearchModel.resetHybridSearchState,
    entitiesMotnModel.resetMotnSearchState,
    searchAutocompleteModel.resetAutocomplete,
  ],
})

sample({
  clock: resetSearchOnProfileSwitch,
  fn: () => [],
  target: api.vods.$realRecommendedVods,
})

sample({
  clock: resetSearchOnProfileSwitch,
  fn: () => null,
  target: [api.globalSearch.$searchResults, api.globalSearch.$searchPageInfo],
})
